var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 63,
    viewBox: "0 0 51 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 25.4081,
    cy: 25.4081,
    r: 25.4081,
    fill: "#EF9796"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M50.8162 25.4082C50.8162 39.4407 39.4406 50.8163 25.4081 50.8163C11.3756 50.8163 0 39.4407 0 25.4082C13.1911 30.096 37.3178 30.4554 50.8162 25.4082Z",
    fill: "#F7E4C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M50.2638 29.8271C47.5021 41.4265 38.6644 50.8165 25.408 50.8165C12.1516 50.8165 2.2093 40.8742 0.552246 29.8271C13.7434 34.5149 36.7653 34.8744 50.2638 29.8271Z",
    fill: "#EBC0A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.701 38.6646C25.509 31.9184 25.509 24.6514 27.701 17.9052L24.8812 16.9883C21.8019 23.4979 20.6033 31.0343 21.7438 38.6646H27.701Z",
    fill: "#B5805A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8016 21.5373L35.2317 19.5985L33.8811 21.3285L30.195 20.5005L30.625 18.5618L29.2744 20.2917L24.0166 19.0968C26.3644 16.5711 29.807 15.3181 33.2472 16.0966C36.6873 16.8751 39.2736 19.4935 40.3276 22.7866L34.8016 21.5373Z",
    fill: "#96D701"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.996 11.309L31.6948 9.82619L32.2818 11.9392L29.4249 14.4328L28.1237 12.95L28.7119 15.063L24.6341 18.6292C23.9977 15.2422 25.0382 11.7094 27.706 9.37764C30.3739 7.04591 34.008 6.48491 37.285 7.56737L32.996 11.309Z",
    fill: "#26C9A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1889 13.5721L19.0737 12.5613L18.8092 14.1146L21.2892 16.2832L22.1727 15.2724L21.9095 16.8257L25.4498 19.9223C25.6327 17.404 24.4847 14.6187 22.1629 12.5922C19.841 10.5657 16.9396 9.80204 14.4683 10.3186L18.1889 13.5721Z",
    fill: "#90CD86"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3884 21.1747L14.1808 19.179L15.3374 21.0746L19.1334 20.673L18.9258 18.6774L20.0824 20.5729L25.4996 19.9971C23.4373 17.1871 20.1219 15.5227 16.578 15.8983C13.0341 16.2739 10.1339 18.5958 8.69434 21.7777L14.3884 21.1747Z",
    fill: "#2FD60A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 42.8326,
    cy: 9.4425,
    r: 3.91906,
    fill: "#FFA800"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_563_919)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.9604,
    cy: 51.3682,
    rx: 12.7041,
    ry: 2.76175,
    fill: "#DE614B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_563_919",
    x: 5.25635,
    y: 40.6064,
    width: 41.4082,
    height: 21.5234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_563_919"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelax);
export default __webpack_public_path__ + "static/media/Relax.f404debe3858310ef2a6768736a9f2f9.svg";
export { ForwardRef as ReactComponent };